import requestFunctions from "../../functions/requestFunctions";


export const state = {

  DIALOGS_MESSAGES_ITEM: {
    'uuid' : null,
    'json_data'  : null,
    'created_at' : null,
    'updated_at' : null,
    'deleted_at' : null
  },
  DIALOGS_MESSAGES_LIST: [],

  DIALOGS_MESSAGES_TABLE_DATA: [],
  DIALOGS_MESSAGES_LIST_DATA: [],

}

export const getters = {

  GET_DIALOGS_MESSAGES_ITEM: (state) => {
    return state.DIALOGS_MESSAGES_ITEM;
  },
  GET_DIALOGS_MESSAGES_LIST: (state) => {
    return state.DIALOGS_MESSAGES_LIST;
  },
  GET_DIALOGS_MESSAGES_TABLE_DATA: (state) => {
    return state.DIALOGS_MESSAGES_TABLE_DATA;
  },
  GET_DIALOGS_MESSAGES_LIST_DATA: (state) => {
    return state.DIALOGS_MESSAGES_LIST_DATA;
  },
  
}

export const mutations = {
  UPDATE_DIALOGS_MESSAGES_ITEM(state, item) {
    state.DIALOGS_MESSAGES_ITEM = item;
  },
  UPDATE_DIALOGS_MESSAGES_LIST(state, data) {

    let list = data.list;
    let action = data.action;

    state.DIALOGS_MESSAGES_LIST = list;

    if(action != 'new') {
      state.DIALOGS_MESSAGES_TABLE_DATA = [];
      state.DIALOGS_MESSAGES_LIST_DATA = [];
    }

    list.forEach(el => {

      let user = null;
      let avatar = null;

      if(el.owner_id === null){
        user = 'Бот';
      }

      if(el.user && el.user.user && el.user.user.email && el.user.user.email !== null){
        user = el.user.user.email;
      }

      if(el.user && el.user.user && el.user.user.telegram_login && el.user.user.telegram_login !== null){
        user = el.user.user.telegram_login;
      }

      if(el.user && el.user.user && el.user.user.phone && el.user.user.phone !== null){
        user = el.user.user.phone;
      }

      if(el.user && el.user.profile && el.user.profile.fullname){
        user = el.user.profile.fullname;
      }

      if(el.user && el.user.user && el.user.user.avatar_img && el.user.user.avatar_img !== null){
        avatar = el.user.user.avatar_img;
      }

      if(user === null){
        user = 'без имени';
      }

      state.DIALOGS_MESSAGES_LIST_DATA.push({
        'id': el.id,
        'dialog_id': el.dialog_id,
        'text': el.text,
        'user': user,
        'owner': el.owner_id,
        'uuid': el.uuid,
        'avatar': avatar,
        'created_at': el.created_at
      });

    });
  },
}

export const actions = {

  async FETCH_DIALOGS_MESSAGES_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dialogs/messages/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_DIALOGS_MESSAGES_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_DIALOGS_MESSAGES_LIST({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/dialogs/messages';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      if(payload.last_message_id){
        commit('UPDATE_DIALOGS_MESSAGES_LIST', {list: response.data, action: 'new'});
      } else {
        commit('UPDATE_DIALOGS_MESSAGES_LIST', {list: response.data, action: 'all'});
      }
      return response.data;
    }
  },

  async FETCH_DIALOGS_MESSAGES_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dialogs/messages';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_DIALOGS_MESSAGES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dialogs/messages/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_DIALOGS_MESSAGES_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dialogs/messages/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}